// extracted by mini-css-extract-plugin
export default {"container":"normal_container__+qIMR","boxContainer":"normal_boxContainer__5BQXk"};